import {Command} from "mobx-graphlink";
import {UserHidden} from "../DB/userHiddens/@UserHidden.js";

const MTClass = UserHidden;
type MT = typeof MTClass.prototype;

export class UpdateUserHidden extends Command<{id: string, updates: Partial<MT>}, {}> {
	/*oldData: MainType;
	newData: MainType;
	Validate() {
		AssertValidate({
			properties: {
				id: {type: "string"},
				updates: NewSchema({
					properties: GetSchemaJSON(MTName)["properties"]!.IncludeKeys(
						"email", "providerData",
						//"backgroundID", "backgroundCustom_enabled", "backgroundCustom_color", "backgroundCustom_url", "backgroundCustom_position",
						"customGridExtractor_enabled", "customGridExtractor_regex", "gridEntityNames",
					),
				}),
			},
			required: ["id", "updates"],
		}, this.payload, "Payload invalid");

		const {id, updates} = this.payload;
		this.oldData = GetUserHidden.NN(id);
		this.newData = {...this.oldData, ...updates};
		AssertValidate(MTName, this.newData, `New ${MTName.toLowerCase()}-data invalid`);
	}

	DeclareDBUpdates(db: DBHelper) {
		const {id} = this.payload;
		db.set(dbp`users_private/${id}`, this.newData);
	}*/
}